// Projects Data — Architecture References (Referenzen)
// Images imported from src/assets/ project folders

// Frenkendorf
import frenkendorf1 from '../assets/Frenkendorf/1.jpg';
import frenkendorf2 from '../assets/Frenkendorf/2.jpg';
import frenkendorf3 from '../assets/Frenkendorf/3.jpg';
import frenkendorf4 from '../assets/Frenkendorf/4.jpg';
import frenkendorf5 from '../assets/Frenkendorf/5.jpg';

// Amriswil
import amriswil1 from '../assets/amriswil/1.jpg';
import amriswil2 from '../assets/amriswil/2.jpg';
import amriswil3 from '../assets/amriswil/3.jpg';

// Zwingen
import zwingen1 from '../assets/mfh_zwingen/1.jpg';
import zwingen2 from '../assets/mfh_zwingen/2.jpg';
import zwingen3 from '../assets/mfh_zwingen/3.jpg';
import zwingen4 from '../assets/mfh_zwingen/4.jpg';
import zwingen5 from '../assets/mfh_zwingen/5.jpg';
import zwingen6 from '../assets/mfh_zwingen/6.jpg';
import zwingen7 from '../assets/mfh_zwingen/7.jpg';

// Andwil
import andwil1 from '../assets/andwil/1.webp';
import andwil2 from '../assets/andwil/2.webp';
import andwil3 from '../assets/andwil/3.webp';
import andwil4 from '../assets/andwil/4.webp';
import andwil5 from '../assets/andwil/5.jpg';
import andwil6 from '../assets/andwil/6.jpg';

// Allschwil
import allschwil1 from '../assets/allschwil/1.jpg';
import allschwil2 from '../assets/allschwil/2.jpg';
import allschwil3 from '../assets/allschwil/3.jpg';
import allschwil4 from '../assets/allschwil/4.jpg';
import allschwil5 from '../assets/allschwil/5.jpg';
import allschwil6 from '../assets/allschwil/6.jpg';
import allschwil7 from '../assets/allschwil/7.jpg';

// Füllinsdorf
import fullinsdorf1 from '../assets/füllinsdorf/1.jpg';
import fullinsdorf2 from '../assets/füllinsdorf/2.jpg';
import fullinsdorf3 from '../assets/füllinsdorf/3.jpg';

// Zollikofen
import zollikofen1 from '../assets/zollikofen/1.jpg';
import zollikofen2 from '../assets/zollikofen/2.jpg';
import zollikofen3 from '../assets/zollikofen/3.jpg';
import zollikofen4 from '../assets/zollikofen/4.jpg';
import zollikofen5 from '../assets/zollikofen/5.jpg';

// Möhlin
import mohlin1 from '../assets/möhlin/1.jpg';
import mohlin2 from '../assets/möhlin/2.PNG';
import mohlin3 from '../assets/möhlin/3.jpg';
import mohlin4 from '../assets/möhlin/4.PNG';
import mohlin5 from '../assets/möhlin/5.jpg';
import mohlin6 from '../assets/möhlin/6.jpg';
import mohlin7 from '../assets/möhlin/7.jpg';
import mohlin8 from '../assets/möhlin/8.jpg';
import mohlin9 from '../assets/möhlin/9.jpg';

// EFH Sirnach
import sirnach1 from '../assets/efh_sirnach/1.jpg';
import sirnach2 from '../assets/efh_sirnach/2.jpg';

// Hotel Zürich
import hotel1 from '../assets/hotel/1.jpg';
import hotel2 from '../assets/hotel/2.jpg';
import hotel3 from '../assets/hotel/3.jpg';
import hotel4 from '../assets/hotel/4.jpg';

export const projectsData = [
  {
    id: 1,
    title: 'NEUBAU REFH FRENKENDORF',
    location: 'Frenkendorf, Schweiz',
    year: '2025',
    type: 'Reiheneinfamilienhäuser',
    mainImage: frenkendorf1,
    description:
      'Für dieses Projekt wurden wir mit der Optimierung eines bestehenden Entwurfs sowie der gestalterischen Weiterentwicklung beauftragt. Durch gezielte Anpassungen konnte die architektonische Qualität verbessert und eine bewilligungsfähige Lösung erarbeitet werden.',
    details: 'Jahr: 2025 | Typologie: 3 Reiheneinfamilienhäuser | Auftrag: Projektoptimierung und Gestaltung',
    gallery: [frenkendorf1, frenkendorf2, frenkendorf3, frenkendorf4, frenkendorf5]
  },
  {
    id: 2,
    title: 'NEUBAU MFH AMRISWIL',
    location: 'Amriswil, Schweiz',
    year: '2025–2028',
    type: 'Mehrfamilienhaus',
    mainImage: amriswil1,
    description:
      'Das Projekt umfasst die Planung und Realisierung eines Mehrfamilienhauses. Der Fokus liegt auf einer klaren architektonischen Sprache, effizienten Grundrissen und einer hochwertigen Umsetzung.',
    details: 'Jahr: 2025–2028 | Typologie: Mehrfamilienhaus | Auftrag: Entwurf und Ausführung',
    gallery: [amriswil1, amriswil2, amriswil3]
  },
  {
    id: 3,
    title: 'NEUBAU MFH ZWINGEN',
    location: 'Zwingen, Schweiz',
    year: '2025',
    type: 'Mehrfamilienhaus',
    mainImage: zwingen1,
    description:
      'Für dieses Mehrfamilienhaus entwickelten wir ein architektonisches Konzept mit funktionalen Grundrissen und einem präzisen gestalterischen Ausdruck.',
    details: 'Jahr: 2025 | Typologie: Mehrfamilienhaus | Auftrag: Entwurf',
    gallery: [zwingen1, zwingen2, zwingen3, zwingen4, zwingen5, zwingen6, zwingen7]
  },
  {
    id: 4,
    title: 'NEUBAU EFH ANDWIL',
    location: 'Andwil, Schweiz',
    year: '2024',
    type: 'Einfamilienhaus',
    mainImage: andwil6,
    description:
      'Entwurf eines Einfamilienhauses mit Fokus auf klare Raumstrukturen, Tageslichtführung und eine zeitgemässe architektonische Gestaltung.',
    details: 'Jahr: 2024 | Typologie: Einfamilienhaus | Auftrag: Entwurf',
    gallery: [andwil6, andwil5, andwil4, andwil1, andwil2, andwil3]
  },
  {
    id: 5,
    title: 'NEUBAU MFH ALLSCHWIL',
    location: 'Allschwil, Schweiz',
    year: '2025',
    type: 'Mehrfamilienhaus',
    mainImage: allschwil1,
    description:
      'Das Projekt beinhaltet die Entwicklung vom Entwurf bis zur Baueingabe. Ziel war eine wirtschaftliche und gestalterisch überzeugende Lösung im Kontext der Umgebung.',
    details: 'Jahr: 2025 | Typologie: Mehrfamilienhaus | Auftrag: Entwurf, Bauprojekt und Baueingabe',
    gallery: [allschwil1, allschwil2, allschwil3, allschwil4, allschwil5, allschwil6, allschwil7]
  },
  {
    id: 6,
    title: 'SANIERUNG EFH FÜLLINSDORF',
    location: 'Füllinsdorf, Schweiz',
    year: '2024',
    type: 'Einfamilienhaus',
    mainImage: fullinsdorf1,
    description:
      'Im Rahmen der Sanierung wurde das bestehende Gebäude räumlich und energetisch aufgewertet und an heutige Anforderungen angepasst.',
    details: 'Jahr: 2024 | Typologie: Einfamilienhaus | Auftrag: Entwurf, Bauprojekt und Baueingabe',
    gallery: [fullinsdorf1, fullinsdorf2, fullinsdorf3]
  },
  {
    id: 7,
    title: 'NEUBAU MFH ZOLLIKOFEN',
    location: 'Zollikofen, Schweiz',
    year: '2024',
    type: 'Mehrfamilienhaus',
    mainImage: zollikofen1,
    description:
      'Entwicklung eines klar strukturierten Mehrfamilienhauses mit effizienter Organisation und hoher Wohnqualität.',
    details: 'Jahr: 2024 | Typologie: Mehrfamilienhaus | Auftrag: Entwurf',
    gallery: [zollikofen1, zollikofen2, zollikofen3, zollikofen4, zollikofen5]
  },
  {
    id: 8,
    title: 'NEUBAU MFH MÖHLIN',
    location: 'Möhlin, Schweiz',
    year: '2024',
    type: 'Mehrfamilienhaus',
    mainImage: mohlin5,
    description:
      'Entwicklung eines klar strukturierten Mehrfamilienhauses mit effizienter Organisation und hoher Wohnqualität.',
    details: 'Jahr: 2024 | Typologie: Mehrfamilienhaus | Auftrag: Machbarkeitsstudie, Entwurf',
    gallery: [mohlin5, mohlin6, mohlin7, mohlin4, mohlin2, mohlin3, mohlin1, mohlin8, mohlin9]
  },
  {
    id: 9,
    title: 'NEUBAU EFH SIRNACH',
    location: 'Sirnach, Schweiz',
    year: '2025',
    type: 'Einfamilienhaus',
    mainImage: sirnach1,
    description:
      'Planung eines Einfamilienhauses mit besonderem Fokus auf Funktionalität, Proportionen und Materialisierung.',
    details: 'Jahr: 2025 | Typologie: Einfamilienhaus | Auftrag: Entwurf, Bauprojekt und Baueingabe',
    gallery: [sirnach1, sirnach2]
  },
  {
    id: 10,
    title: 'SANIERUNG HOTEL ZÜRICH',
    location: 'Zürich, Schweiz',
    year: '2024',
    type: 'Hotel',
    mainImage: hotel1,
    description:
      'Im Rahmen einer Machbarkeitsstudie wurden verschiedene Szenarien zur Weiterentwicklung und Sanierung des bestehenden Hotels untersucht und bewertet.',
    details: 'Jahr: 2024 | Typologie: Hotel | Auftrag: Machbarkeitsstudie',
    gallery: [hotel1, hotel2, hotel3, hotel4]
  }
];
